// Generic overlay elements (drawer + modal) reusing theme.trapFocus.
// Open with [data-overlay-open="<id>"]; close with [data-overlay-close] or scrim/Escape.
(function () {
  class Overlay extends HTMLElement {
    connectedCallback() {
      document.querySelectorAll('[data-overlay-open="' + this.id + '"]').forEach((b) =>
        b.addEventListener("click", (e) => {
          e.preventDefault();
          // A click that opens an overlay must not also read as an "outside click" to
          // document-level listeners. <predictive-search> closes its panel on any such
          // click, which would shut the panel that data-autofocus just opened.
          e.stopPropagation();
          this.open();
        })
      );
      this.addEventListener("click", (e) => {
        if (e.target.closest("[data-overlay-close]") || e.target.matches("[data-overlay-scrim]")) this.close();
      });
      this._onKey = (e) => { if (e.key === "Escape" && this.classList.contains("is-open")) this.close(); };
    }
    open() {
      this.classList.add("is-open");
      this.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", this._onKey);
      this._release = window.theme.trapFocus(this);
      this.dispatchEvent(new CustomEvent("overlay:open", { bubbles: true }));
      // Declarative autofocus via data-autofocus="<selector>". Kept synchronous
      // inside the click: iOS Safari only raises the keyboard for programmatic focus
      // during a user gesture. The offsetWidth read forces a style flush first --
      // .is-open was added in this same task and focus() is a no-op on a still
      // visibility:hidden element.
      const sel = this.dataset.autofocus;
      if (sel) {
        const target = this.querySelector(sel);
        if (target) { void this.offsetWidth; target.focus(); }
      }
    }
    close() {
      this.classList.remove("is-open");
      this.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      document.removeEventListener("keydown", this._onKey);
      if (this._release) { this._release(); this._release = null; }
      // Paired with overlay:open. The newsletter popup needs it to tell "closed without
      // subscribing" (ask again later) from "subscribed" (never ask again).
      this.dispatchEvent(new CustomEvent("overlay:close", { bubbles: true }));
    }
  }
  customElements.define("theme-drawer", class extends Overlay {});
  customElements.define("theme-modal", class extends Overlay {});
})();
